
import React from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ImagePreviewProps } from './types';

const ImagePreview: React.FC<ImagePreviewProps> = ({
  imageUrl,
  onRemove,
  previewHeight = 'max-h-48',
  previewClassName,
  disabled = false
}) => {
  if (!imageUrl) return null;
  
  return (
    <div className="relative">
      <img 
        src={imageUrl} 
        alt="Preview" 
        className={cn("rounded-md object-contain border p-1", previewHeight, previewClassName)}
      />
      <Button
        type="button"
        variant="destructive"
        size="icon"
        className="absolute top-2 right-2"
        onClick={onRemove}
        disabled={disabled}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ImagePreview;
